import React, { useState } from "react";
import styled from "styled-components";
import { Accordion, AccordionSummary, AccordionDetails, Typography } from "@material-ui/core";
import { IPageSectionResponse } from "models/response/page-section-response";
import { SectionTitle } from "../custom-page.styles";

// ExpandMore Icon Component
const ExpandMoreIcon: React.FC = () => (
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="currentColor"
    >
        <path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z" />
    </svg>
);

const AccordionContainer = styled.div`
  margin-bottom: 30px;
`;

const StyledAccordion = styled(Accordion)`
  margin-bottom: 10px !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1) !important;
  border-radius: 8px !important;

  &:before {
    display: none;
  }

  &.Mui-expanded {
    margin-bottom: 10px !important;
  }
`;

const StyledAccordionSummary = styled(AccordionSummary)`
  background-color: #f5f5f5;
  border-radius: 8px !important;

  &.Mui-expanded {
    border-bottom-left-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
  }

  .MuiAccordionSummary-content {
    margin: 12px 0;
  }
`;

const QuestionText = styled(Typography)`
  font-weight: 600 !important;
  font-size: 1rem !important;
  color: #333;

  @media (max-width: 768px) {
    font-size: 1rem !important;
  }
`;

const StyledAccordionDetails = styled(AccordionDetails)`
  padding: 20px !important;
  background-color: #fff;
`;

const AnswerText = styled(Typography)`
  font-size: 1rem !important;
  line-height: 1.7 !important;
  color: #555;

  @media (max-width: 768px) {
    font-size: 1rem !important;
  }
`;

interface AccordionFaqSectionProps {
    section: IPageSectionResponse;
}

export const AccordionFaqSection: React.FC<AccordionFaqSectionProps> = ({ section }) => {
    const [expanded, setExpanded] = useState<number | false>(false);

    const handleChange = (panel: number) => (_event: React.ChangeEvent<{}>, isExpanded: boolean) => {
        setExpanded(isExpanded ? panel : false);
    };

    if (!section.items || section.items.length === 0) {
        return null;
    }

    const sortedItems = [...section.items].sort((a, b) => a.order - b.order);

    return (
        <AccordionContainer>
            {section.title && <SectionTitle>{section.title}</SectionTitle>}
            {sortedItems.map((item, index) => (
                <StyledAccordion
                    key={item.id}
                    expanded={expanded === index}
                    onChange={handleChange(index)}
                >
                    <StyledAccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls={`panel${index}-content`}
                        id={`panel${index}-header`}
                    >
                        <QuestionText>{item.title || item.subtitle}</QuestionText>
                    </StyledAccordionSummary>
                    <StyledAccordionDetails>
                        <AnswerText>{item.description}</AnswerText>
                    </StyledAccordionDetails>
                </StyledAccordion>
            ))}
        </AccordionContainer>
    );
};
